import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api, { extrairErro } from '../services/api';
import { enviarEvidencias } from '../services/evidencias';
import FormDenuncia from '../components/FormDenuncia';
import StatusCard from '../components/StatusCard';
import { IconArrowLeft, IconAlert } from '../components/icons';

function DenunciaAnonima() {
  const navigate = useNavigate();
  const location = useLocation();
  const unidadePre = location.state?.unidadePre;
  const [categorias, setCategorias] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [resultado, setResultado] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [catRes, unidRes] = await Promise.all([
          api.get('/public/categorias', { params: { tipo: 'denuncia' } }),
          api.get('/public/unidades')
        ]);
        setCategorias(catRes.data);
        setUnidades(unidRes.data);
      } catch (err) {
        setError('Erro ao carregar dados. Tente novamente.');
        console.error(err);
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (formData) => {
    setLoading(true);
    setError(null);
    try {
      const { evidencias, ...dados } = formData;
      const res = await api.post('/public/manifestacoes', {
        ...dados,
        tipo: 'denuncia',
        anonima: true,
        origem: 'portal'
      });
      const { protocolo, pin } = res.data;

      try {
        await enviarEvidencias(protocolo, pin, evidencias);
      } catch (err) {
        // A denúncia já está registrada: mostrar o protocolo importa mais que o anexo.
        setError('Denúncia registrada, mas houve falha ao enviar os anexos.');
        console.error(err);
      }

      setResultado({ protocolo, pin });
    } catch (err) {
      setError(extrairErro(err, 'Erro ao enviar denúncia'));
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (resultado) {
    return (
      <div className="container">
        <button className="btn-back" onClick={() => navigate('/')}><IconArrowLeft /> Início</button>
        <StatusCard
          titulo="Denúncia recebida com sucesso"
          protocolo={resultado.protocolo}
          pin={resultado.pin}
        />
      </div>
    );
  }

  return (
    <div className="container">
      <button className="btn-back" onClick={() => navigate('/')}><IconArrowLeft /> Início</button>
      <div className="step-heading">
        <p className="eyebrow">Ouvir · Proteger · Construir juntos</p>
        <h2>Denúncia anônima</h2>
        <p className="info-text">Sua identidade será protegida. Nenhum dado pessoal será coletado.</p>
      </div>
      {error && <div className="error-message"><IconAlert />{error}</div>}
      <FormDenuncia
        categorias={categorias}
        unidades={unidades}
        onSubmit={handleSubmit}
        loading={loading}
        anonima={true}
        unidadePreSelecionada={unidadePre}
      />
    </div>
  );
}

export default DenunciaAnonima;
